var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [!_vm.isStandalone && _vm.showManualInstall ? _c('v-card', {
    class: ['install-prompt-card', 'manual-install', {
      'is-mobile': _vm.isMobile,
      'is-closed': _vm.isClosed
    }],
    attrs: {
      "elevation": "2"
    }
  }, [_c('v-card-text', {
    class: ['pa-0', {
      'banner-layout': !_vm.isMobile,
      'mobile-layout': _vm.isMobile
    }]
  }, [!_vm.isMobile ? _c('div', {
    staticClass: "banner-content-desktop d-flex align-center flex-nowrap"
  }, [_c('v-icon', {
    staticClass: "mr-3 flex-shrink-0 banner-icon",
    attrs: {
      "size": 28,
      "color": "primary"
    }
  }, [_vm._v("mdi-cellphone-link")]), _c('div', {
    staticClass: "mr-4 flex-shrink-1 min-width-0 banner-text-container"
  }, [_c('div', {
    staticClass: "install-title"
  }, [_vm._v("Install App")]), _c('div', {
    staticClass: "install-subtitle"
  }, [_vm._v("Add to your home screen for quick access")])]), _c('div', {
    staticClass: "banner-actions d-flex align-center flex-shrink-0"
  }, [_c('div', {
    staticClass: "dismiss-section d-flex align-center mr-3 flex-shrink-0",
    on: {
      "click": _vm.dismissManualInstall
    }
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "color": "#718096",
      "size": "18"
    }
  }, [_vm._v("mdi-close")]), _c('span', {
    staticClass: "dismiss-text"
  }, [_vm._v("Dismiss")])], 1), _c('div', {
    staticClass: "action-buttons flex-shrink-0"
  }, [!_vm.isIOS && _vm.deferredPrompt ? _c('v-btn', {
    staticClass: "install-btn-black",
    attrs: {
      "outlined": "",
      "color": "black",
      "loading": _vm.installing,
      "rounded": ""
    },
    on: {
      "click": _vm.handleInstall
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "size": "18"
    }
  }, [_vm._v("mdi-plus")]), _vm._v(" Install ")], 1) : _vm.isIOS ? _c('v-btn', {
    staticClass: "install-btn-black",
    attrs: {
      "outlined": "",
      "color": "black",
      "rounded": ""
    },
    on: {
      "click": function ($event) {
        _vm.showIOSInstructions = true;
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "size": "18"
    }
  }, [_vm._v("mdi-plus")]), _vm._v(" Show Instructions ")], 1) : _c('v-btn', {
    staticClass: "install-btn-black",
    attrs: {
      "outlined": "",
      "color": "black",
      "rounded": ""
    },
    on: {
      "click": function ($event) {
        _vm.showBrowserInstructions = true;
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "size": "18"
    }
  }, [_vm._v("mdi-plus")]), _vm._v(" How to Install ")], 1)], 1)])], 1) : _c('div', {
    staticClass: "mobile-content"
  }, [_c('div', {
    staticClass: "d-flex align-center mb-3"
  }, [_c('v-icon', {
    staticClass: "mr-3",
    attrs: {
      "size": 24,
      "color": "primary"
    }
  }, [_vm._v("mdi-cellphone-link")]), _c('div', {
    staticClass: "flex-grow-1"
  }, [_c('div', {
    staticClass: "install-title"
  }, [_vm._v("Install App")]), _c('div', {
    staticClass: "install-subtitle"
  }, [_vm._v("Add to your home screen for quick access")])]), _c('v-btn', {
    staticClass: "ml-2",
    attrs: {
      "icon": "",
      "small": ""
    },
    on: {
      "click": _vm.dismissManualInstall
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "#718096"
    }
  }, [_vm._v("mdi-close")])], 1)], 1), _c('div', {
    staticClass: "mobile-actions"
  }, [_c('v-checkbox', {
    staticClass: "dont-show-checkbox mb-2",
    attrs: {
      "label": "Don't show me this message again",
      "color": "primary",
      "hide-details": ""
    },
    model: {
      value: _vm.dontShowAgain,
      callback: function ($$v) {
        _vm.dontShowAgain = $$v;
      },
      expression: "dontShowAgain"
    }
  }), _c('div', {
    staticClass: "action-buttons"
  }, [!_vm.isIOS && _vm.deferredPrompt ? _c('v-btn', {
    attrs: {
      "color": "primary",
      "loading": _vm.installing,
      "block": "",
      "rounded": ""
    },
    on: {
      "click": _vm.handleInstall
    }
  }, [_vm._v(" Install ")]) : _vm.isIOS ? _c('v-btn', {
    attrs: {
      "color": "primary",
      "block": "",
      "rounded": ""
    },
    on: {
      "click": function ($event) {
        _vm.showIOSInstructions = true;
      }
    }
  }, [_vm._v(" Show Instructions ")]) : _c('v-btn', {
    attrs: {
      "dark": "",
      "color": "black",
      "block": "",
      "rounded": ""
    },
    on: {
      "click": function ($event) {
        _vm.showBrowserInstructions = true;
      }
    }
  }, [_vm._v(" How to Install ")])], 1)], 1)])])], 1) : _vm._e(), _vm.showInstallPrompt && !_vm.isIOS && !_vm.showManualInstall ? _c('v-card', {
    class: ['install-prompt-card', {
      'is-mobile': _vm.isMobile,
      'is-closed': _vm.isClosed
    }],
    attrs: {
      "elevation": "2"
    }
  }, [_c('v-card-text', {
    class: ['pa-0', {
      'banner-layout': !_vm.isMobile,
      'mobile-layout': _vm.isMobile
    }]
  }, [!_vm.isMobile ? _c('div', {
    staticClass: "banner-content-desktop d-flex align-center flex-nowrap"
  }, [_c('v-icon', {
    staticClass: "mr-3 flex-shrink-0 banner-icon",
    attrs: {
      "size": 28,
      "color": "primary"
    }
  }, [_vm._v("mdi-download")]), _c('div', {
    staticClass: "mr-4 flex-shrink-1 min-width-0 banner-text-container"
  }, [_c('div', {
    staticClass: "install-title"
  }, [_vm._v("Install Cuetrics")]), _c('div', {
    staticClass: "install-subtitle"
  }, [_vm._v("Add to your home screen for quick access")])]), _c('div', {
    staticClass: "banner-actions d-flex align-center flex-shrink-0"
  }, [_c('div', {
    staticClass: "dismiss-section d-flex align-center mr-3 flex-shrink-0",
    on: {
      "click": _vm.dismissPrompt
    }
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "color": "#718096",
      "size": "18"
    }
  }, [_vm._v("mdi-close")]), _c('span', {
    staticClass: "dismiss-text"
  }, [_vm._v("Dismiss")])], 1), _c('v-btn', {
    staticClass: "install-btn-black flex-shrink-0",
    attrs: {
      "outlined": "",
      "color": "black",
      "loading": _vm.installing,
      "rounded": ""
    },
    on: {
      "click": _vm.handleInstall
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "size": "18"
    }
  }, [_vm._v("mdi-plus")]), _vm._v(" Install ")], 1)], 1)], 1) : _c('div', {
    staticClass: "mobile-content"
  }, [_c('div', {
    staticClass: "d-flex align-center mb-3"
  }, [_c('v-icon', {
    staticClass: "mr-3",
    attrs: {
      "size": 24,
      "color": "primary"
    }
  }, [_vm._v("mdi-download")]), _c('div', {
    staticClass: "flex-grow-1"
  }, [_c('div', {
    staticClass: "install-title"
  }, [_vm._v("Install Cuetrics")]), _c('div', {
    staticClass: "install-subtitle"
  }, [_vm._v("Add to your home screen for quick access")])]), _c('v-btn', {
    staticClass: "ml-2",
    attrs: {
      "icon": "",
      "small": ""
    },
    on: {
      "click": _vm.dismissPrompt
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "#718096"
    }
  }, [_vm._v("mdi-close")])], 1)], 1), _c('div', {
    staticClass: "mobile-actions"
  }, [_c('v-checkbox', {
    staticClass: "dont-show-checkbox mb-2",
    attrs: {
      "label": "Don't show me this message again",
      "color": "primary",
      "hide-details": ""
    },
    model: {
      value: _vm.dontShowAgain,
      callback: function ($$v) {
        _vm.dontShowAgain = $$v;
      },
      expression: "dontShowAgain"
    }
  }), _c('v-btn', {
    attrs: {
      "color": "primary",
      "loading": _vm.installing,
      "block": "",
      "rounded": ""
    },
    on: {
      "click": _vm.handleInstall
    }
  }, [_vm._v(" Install ")])], 1)])])], 1) : _vm._e(), _c('v-dialog', {
    attrs: {
      "max-width": "500",
      "persistent": ""
    },
    model: {
      value: _vm.showBrowserInstructions,
      callback: function ($$v) {
        _vm.showBrowserInstructions = $$v;
      },
      expression: "showBrowserInstructions"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline",
    staticStyle: {
      "color": "#1a202c"
    }
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("mdi-download")]), _vm._v(" Install on Chrome/Edge ")], 1), _c('v-card-text', {
    staticClass: "pt-4"
  }, [_c('div', {
    staticClass: "ios-steps"
  }, [_c('div', {
    staticClass: "step-item"
  }, [_c('v-icon', {
    staticClass: "step-icon",
    attrs: {
      "size": "20",
      "color": "primary"
    }
  }, [_vm._v("mdi-menu")]), _c('span', [_vm._v("Click the "), _c('strong', [_vm._v("menu")]), _vm._v(" icon "), _c('v-icon', {
    attrs: {
      "size": "16",
      "color": "primary"
    }
  }, [_vm._v("mdi-dots-vertical")]), _vm._v(" in the top right corner")], 1)], 1), _c('div', {
    staticClass: "step-item"
  }, [_c('v-icon', {
    staticClass: "step-icon",
    attrs: {
      "size": "20",
      "color": "primary"
    }
  }, [_vm._v("mdi-plus-circle")]), _c('span', [_vm._v("Look for "), _c('strong', [_vm._v("\"Install\"")]), _vm._v(" or "), _c('strong', [_vm._v("\"Add to Home Screen\"")]), _vm._v(" option")])], 1), _c('div', {
    staticClass: "step-item"
  }, [_c('v-icon', {
    staticClass: "step-icon",
    attrs: {
      "size": "20",
      "color": "primary"
    }
  }, [_vm._v("mdi-check")]), _c('span', [_vm._v("Click "), _c('strong', [_vm._v("\"Install\"")]), _vm._v(" to add the app")])], 1)]), _c('v-alert', {
    staticClass: "mt-4",
    attrs: {
      "type": "info",
      "outlined": "",
      "dense": ""
    }
  }, [_c('small', [_vm._v("If you don't see the install option, make sure you're using HTTPS and the app meets PWA requirements.")])])], 1), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function ($event) {
        _vm.showBrowserInstructions = false;
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1), _vm.showIOSInstructions ? _c('v-card', {
    class: ['install-prompt-card', 'ios-instructions', {
      'is-mobile': _vm.isMobile,
      'is-closed': _vm.isClosed
    }],
    attrs: {
      "elevation": "2"
    }
  }, [_c('v-card-text', {
    class: ['pa-0', {
      'banner-layout': !_vm.isMobile,
      'mobile-layout': _vm.isMobile
    }]
  }, [!_vm.isMobile ? _c('div', {
    staticClass: "banner-content-desktop d-flex align-center flex-nowrap"
  }, [_c('v-icon', {
    staticClass: "mr-3 flex-shrink-0 banner-icon",
    attrs: {
      "size": 28,
      "color": "primary"
    }
  }, [_vm._v("mdi-apple")]), _c('div', {
    staticClass: "mr-4 flex-shrink-1 min-width-0 banner-text-container"
  }, [_c('div', {
    staticClass: "install-title"
  }, [_vm._v("Install on iPhone/iPad")]), _c('div', {
    staticClass: "install-subtitle"
  }, [_vm._v("Add to your home screen")])]), _c('div', {
    staticClass: "banner-actions d-flex align-center flex-shrink-0"
  }, [_c('div', {
    staticClass: "dismiss-section d-flex align-center mr-3 flex-shrink-0",
    on: {
      "click": _vm.dismissIOSInstructions
    }
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "color": "#718096",
      "size": "18"
    }
  }, [_vm._v("mdi-close")]), _c('span', {
    staticClass: "dismiss-text"
  }, [_vm._v("Dismiss")])], 1)])], 1) : _c('div', {
    staticClass: "mobile-content"
  }, [_c('div', {
    staticClass: "d-flex align-center mb-3"
  }, [_c('v-icon', {
    staticClass: "mr-3",
    attrs: {
      "size": 24,
      "color": "primary"
    }
  }, [_vm._v("mdi-apple")]), _c('div', {
    staticClass: "flex-grow-1"
  }, [_c('div', {
    staticClass: "install-title"
  }, [_vm._v("Install on iPhone/iPad")]), _c('div', {
    staticClass: "install-subtitle"
  }, [_vm._v("Add to your home screen")])]), _c('v-btn', {
    attrs: {
      "icon": "",
      "small": ""
    },
    on: {
      "click": _vm.dismissIOSInstructions
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "#718096"
    }
  }, [_vm._v("mdi-close")])], 1)], 1), _c('div', {
    staticClass: "ios-steps mb-3"
  }, [_c('div', {
    staticClass: "step-item"
  }, [_c('v-icon', {
    staticClass: "step-icon",
    attrs: {
      "size": "20",
      "color": "primary"
    }
  }, [_vm._v("mdi-menu")]), _c('span', [_vm._v("Tap the "), _c('strong', [_vm._v("Share")]), _vm._v(" button "), _c('v-icon', {
    attrs: {
      "size": "16",
      "color": "primary"
    }
  }, [_vm._v("mdi-share-variant")]), _vm._v(" at the bottom")], 1)], 1), _c('div', {
    staticClass: "step-item"
  }, [_c('v-icon', {
    staticClass: "step-icon",
    attrs: {
      "size": "20",
      "color": "primary"
    }
  }, [_vm._v("mdi-plus-circle")]), _c('span', [_vm._v("Scroll down and tap "), _c('strong', [_vm._v("\"Add to Home Screen\"")])])], 1), _c('div', {
    staticClass: "step-item"
  }, [_c('v-icon', {
    staticClass: "step-icon",
    attrs: {
      "size": "20",
      "color": "primary"
    }
  }, [_vm._v("mdi-check")]), _c('span', [_vm._v("Tap "), _c('strong', [_vm._v("\"Add\"")]), _vm._v(" to confirm")])], 1)]), _c('v-checkbox', {
    staticClass: "dont-show-checkbox",
    attrs: {
      "label": "Don't show me this message again",
      "color": "primary",
      "hide-details": ""
    },
    model: {
      value: _vm.dontShowAgain,
      callback: function ($$v) {
        _vm.dontShowAgain = $$v;
      },
      expression: "dontShowAgain"
    }
  })], 1)])], 1) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }